import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e4202df0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "image_hero__wrapper" };
const _hoisted_2 = ["src", "alt", "title"];
const _hoisted_3 = ["src", "alt", "title"];
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'hero_image',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const imageHero = ref(null);
        const shouldShowSquareImage = ref(false);
        onMounted(() => {
            setImageHeight();
            checkWindowSize();
            // Recalculate the height of image_hero on window resize
            window.addEventListener('resize', () => {
                if (imageHero.value) {
                    setImageHeight();
                    checkWindowSize();
                }
            });
            // Attach scroll event listener to check the content position when scrolling
            window.addEventListener('scroll', checkContentAbove);
            // Set the height of image_hero to the viewport height
            if (imageHero.value) {
                setImageHeight();
                // After the next tick, add margin-top to the next element
                nextTick(() => {
                    const nextElement = imageHero.value.nextElementSibling;
                    if (nextElement) {
                        if (props.d.square_image) {
                            if (shouldShowSquareImage.value) {
                                nextElement.style.marginTop = `${window.innerWidth}px`;
                                // Set styling for square image
                                imageHero.value.style.height = `${window.innerWidth}px`;
                                imageHero.value.querySelector('img').style.height = `${window.innerWidth}px`;
                            }
                            else {
                                nextElement.style.marginTop = `${window.innerHeight}px`;
                                // Revert styling for square image
                                imageHero.value.style.height = `unset`;
                                imageHero.value.querySelector('img').style.height = `unset`;
                            }
                        }
                        else {
                            nextElement.style.marginTop = `${window.innerHeight}px`;
                        }
                    }
                });
            }
        });
        function setImageHeight() {
            if (props.d.square_image) {
                if (shouldShowSquareImage.value) {
                    imageHero.value.style.height = `${window.innerWidth}px`;
                    // Set styling for square image
                    imageHero.value.style.height = `${window.innerWidth}px`;
                    imageHero.value.querySelector('img').style.height = `${window.innerWidth}px`;
                }
                else {
                    imageHero.value.style.height = `${window.innerHeight}px`;
                    // Revert styling for square image
                    imageHero.value.style.height = `unset`;
                    imageHero.value.querySelector('img').style.height = `unset`;
                }
            }
            else {
                imageHero.value.style.height = `${window.innerHeight}px`;
            }
        }
        // Function to check window size and update shouldShowSquareImage
        const checkWindowSize = () => {
            shouldShowSquareImage.value = window.innerWidth <= 760;
        };
        checkWindowSize();
        function checkContentAbove() {
            const imageHeroElement = document.querySelector('.image_hero');
            if (imageHeroElement) {
                const windowHeight = window.innerHeight;
                const scrollPosition = window.scrollY;
                // Check if scrolled down 100vh
                if (scrollPosition >= windowHeight) {
                    imageHeroElement.style.zIndex = '-5';
                }
                else {
                    imageHeroElement.style.zIndex = '-1';
                }
            }
        }
        // Call the function initially to check the content position
        checkContentAbove();
        onUnmounted(() => {
            window.removeEventListener('resize', checkWindowSize);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["image_hero", { 'image_hero__smaller': shouldShowSquareImage.value && __props.d.square_image }]),
                ref_key: "imageHero",
                ref: imageHero
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (!shouldShowSquareImage.value || !__props.d.square_image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: __props.d.image,
                            alt: __props.d.alt,
                            title: __props.d.alt,
                            class: "image_hero__image"
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    (__props.d.square_image && shouldShowSquareImage.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: __props.d.square_image,
                            alt: __props.d.alt,
                            title: __props.d.alt,
                            class: "image_hero__image"
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
